import hyperdom from 'hyperdom'
import qs from 'qs'
import BasePaymentMethod from './basePaymentMethod.jsx'
import clone from 'root-core/utils/object/clone.js'
import {iframeResizer} from 'iframe-resizer'

export default class PaymentServices extends BasePaymentMethod{
  constructor (payment) {
    super(payment)
    this.booking = payment.booking
    this.billingAddress = payment.billingAddress
    this.displayName = 'Credit Card'
    this.paymentServicesUrl = payment.config.paymentServicesUrl
  }

  eligible () {
    return this.booking.booking.paymentMethods.creditCard
  }

  book () {
  }

  renderPaymentSummary () {
  }

  renderTermsAndConditions () {
  }

  renderPaymentOption () {
    return [
      <div>{this.displayName}</div>,
      <div class='cards'>
        <div class='card-icon'></div>
      </div>,
    ]
  }

  render () {
    var paymentFormSrc = `${this.paymentServicesUrl}makePayment/${this.payment.config.sellingCompanyCode}/${this.payment.booking.booking.bookingId}`
    var billingAddress = clone(this.payment.quoteCriteria.leadPassenger.address)
    var countryCode = Object.keys(this.payment.countries()).find(code => this.payment.countries()[code].name === billingAddress.country).toUpperCase()
    var search = {
      postMessage: true,
      cardTypes: this.payment.supportedCardTypes.map(c => c.toUpperCase()).join(','),
      amount: this.payment.calculatePaymentAmount(),
      bookingType: this.payment.bookingType,
      bill_to_email: this.payment.quoteCriteria.leadPassenger.emailAddress,
      bill_to_address_line1: billingAddress.line1,
      bill_to_address_line2: billingAddress.line2,
      bill_to_address_city: billingAddress.city,
      bill_to_address_state_name: billingAddress.region,
      bill_to_address_country: countryCode,
      bill_to_address_postal_code: billingAddress.postcode,
      paypalEnabled: this.payment.isPayPalEligible() || undefined,
    }
    const checkOrigin = typeof process === 'undefined' || !process.env.DISABLE_SAME_ORIGIN
    const paymentMethodSelection = this.payment.renderPaymentMethodSelection()
    const paymentServicesIframeSrc = paymentFormSrc + '?' + qs.stringify(search)

    if (paymentServicesIframeSrc != this.latestPaymentServicesUrl) {
      this.payment.showLoading()
      this.latestPaymentServicesUrl = paymentServicesIframeSrc
    }

    const paymentMethod = this

    return hyperdom.viewComponent({
      onadd () {
        iframeResizer({checkOrigin}, '#paymentServicesForm')
      },

      render () {
        return <div>
          {
            paymentMethodSelection ? <div class='o-accent-box'>{ paymentMethodSelection }</div> : ''
          }
          <iframe id='paymentServicesForm' class='payment-iframe'
            data-hj-allow-iframe={paymentMethod.payment.config.features.allowHotjarTrackIFrame}
            src={paymentMethod.latestPaymentServicesUrl}
            onload={() => paymentMethod.payment.hideLoading()}
            scrolling='no'
            width='100%' />
        </div>
      },
    })
  }
}
